import { RefObject, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_KEY = 'scroll_restoration_v1';

// useScrollRestoration saves the scroll position of a container (defaulting to
// window) to sessionStorage keyed by pathname on every route change, and
// restores it when the user navigates back. New forward navigations scroll to
// top. Pass a containerRef when the scrollable element is not window (e.g.,
// a layout's <main> with overflow-y-auto).
export function useScrollRestoration(
  containerRef?: RefObject<HTMLElement | null>,
): void {
  const location = useLocation();
  const prevPath = useRef<string>(location.pathname);
  useEffect(() => {
    const el = containerRef?.current ?? null;
    const readY = (): number => (el ? el.scrollTop : window.scrollY);
    const writeY = (y: number): void => {
      if (el) el.scrollTop = y;
      else window.scrollTo(0, y);
    };
    try {
      const map = JSON.parse(sessionStorage.getItem(SCROLL_KEY) ?? '{}');
      map[prevPath.current] = readY();
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify(map));
    } catch {
      // ignored
    }
    try {
      const map = JSON.parse(sessionStorage.getItem(SCROLL_KEY) ?? '{}');
      const saved = map[location.pathname];
      if (typeof saved === 'number') {
        writeY(saved);
      } else {
        writeY(0);
      }
    } catch {
      writeY(0);
    }
    prevPath.current = location.pathname;
  }, [location.pathname, containerRef]);
}
